import { createFileRoute } from '@tanstack/react-router';
import { ReviewLayout } from '../../layouts/Review/ReviewLayout';

export const Route = createFileRoute('/$retailer/review')({
  component: ReviewLayout,
});
